export const en = {
  language: "English",
  home: {
    WelcometoTaarteb:"Welcome to Taarteb",
    Effortless: "Effortless Student Attendance Tracking",
    Say: "Say goodbye to manual roll calls and paperwork. Our smart system helps schools track attendance, notify parents instantly, and generate insightful reports—all in one place.",
    GetStarted: "Get Started",
    QuickSummary: "Quick Summary",
    Summary: "Summary",
    TotalTeachers: "Total Teachers",
    TotalClasses: "Total Classes",
    TotalStudents: "Total Students",
        search:"Search .......",
    Verify:"Verify",
    VerifyProduct:"Verify Product",
Getintouch:"Get in touch",
    "whatsapp":"Whatsapp",
    "Address":"Address",
    "AddressValue":"Ismailia, Egypt",
Exchange:"Exchange and Return Policy",
    privacy:"Privacy Policy",
shipping:"Shipping / Service Duration Policy",
    "categories": "Categories",
addtocart:"Add to Card",

TrackOrder:"Track Order",
OrderCode:"Enter Your Order Code to track your order",


products:"Products",
aboutus:"Aboutus",
CartEmpty:"Cart Empty",
Wishlist:"Wishlist",

    WeeklyAttendanceReport: "Weekly Attendance Report",
    aboutusFooter:"Luxuriously body care products",
Shoppingcart:"Shopping cart",

    AttendedAbsent: "Attended / Absent",
    
    Absent: "Absent",
    Attended: "Attended",
    TotalStudentsText: "Total Students",
    Welcome:"Welcome to",
    "ManageYourSchoolsEfficiently":"Manage Your Schools Efficiently",
"TotalSchools":"Total Schools",
    "ParentPhone": "Parent phone",
    enter:"Enter",
logoutState:"Are you sure you want to log out?",
    "abouttitle": "Why Choose Our System?",
    "aboutsubtitle": "Our system is simple and efficient—just 3 easy steps",
    "feature1title": "Automated Attendance Tracking",
    "feature1description": "Say goodbye to manual roll calls! Teachers can mark attendance with a single click, and absences are recorded instantly.",
    "feature2title": "Multi-User Access & Role-Based Permissions",
    "feature2description": "Designed for administrators and teachers, ensuring that everyone has the right level of access to the data they need.",
    "feature3title": "Cloud-Based & Secure",
    "feature3description": "Access the system from anywhere, on any device with full data encryption and secure cloud storage to protect student information.",
    "feature4title": "Customizable Attendance Policies",
    "feature4description": "Schools can define their own attendance rules, late policies, and absence thresholds, making the system adaptable to different educational institutions.",

    "howtitle": "How It Works? Step-by-Step Guide",
    "howdescription": "Our system is simple and efficient—just 3 easy steps",
    "step1Title": "Login In The System",
    "step1Description": "Teachers & students sign in securely from any device.",
    "step2Title": "Mark Attendance",
    "step2Description": "Easily track student attendance with a single click.",
    "step3Title": "Notify & Generate Reports",
    "step3Description":
      "Receive real-time updates, and schools get insightful attendance reports.",
    "contacttitle": "Contact Us",
    "contactsubtitle": "Any question or remarks? Just write us a message!",
    "contactInfo": "Contact Information",
    "phone": "Phone Number",
Notes:"Notes",
Payment:"Payment Methods",
Cash:"Cash",
    myAddresses:"My Addresses",
    addNewAddress:"Add New Address",
    city:"City",
    buildingNumber:"Building Number",
    street:"Street",
    region:"region",
Detailedaddress:"Detailed address",
    Registration:"Registration",
    "email": "Email",
    "ParentEmailAddress":"Parent Email address",
    "location": "15 Tahrir Street, Downtown, Cairo, Egypt, 11511",
    "namePlaceholder": "Name",
    "phonePlaceholder": "Phone Number",
    "messagePlaceholder": "Write your message...",
    "sendMessage": "Send Message",
    "Loading": "Loading.........",
    "reachUs": "Reach us",
    "quickLinks": "Quick Links",
    "home": "Home",
    "howItWorks": "How it works?",
    "contactUs": "Contact Us",
    "newsletterTitle": "Join Our Newsletter",
    "newsletterPlaceholder": "Your email address",
    "subscribe": "Subscribe",
    "newsletterNote": "* We will send you weekly updates for better tool management.",
    "features": "Features",
    "login": "Login",
    orderdate:"Order date",
        haveanaccount:"  Already have an account?",

    "user": "User",
    "language": "English",
    "switchTo": "Arabic",
    "welcome": "Welcome, Log into your account",
    "subtitle": "It is our great pleasure to have you on board!",
    "emailPlaceholder": "Email address",
        "ConfirmPassword": "Confirm Password",
Recoverpassword:"Recover password",
RememberyourpasswordRecoverpassword:"Remembered your password Recover password ?",
resetPassword:"Reset Password",
    "passwordPlaceholder": " Password",
    ForgotPassword:"Forgot Password?",
    house_number:"House number",

    Createyouraccount:"Create your account",
      Newcustomer:"New customer?",
    "loggingIn": "Logging in...",
    "fillFields": "Please fill all fields",
    "invalidCredentials": "Invalid credentials, please try again.",
    "successMessage": "Logged in successfully!",
    "addsuccessMessage": "Added successfully!",
    "addsuccessMessage": "Added successfully!",
    "createorder": "The request was created successfully.",
    "ordersuccessMessage": "order completed successfully",
    "deletesuccessMessage": "Deleted successfully !",
pending:"Pending",
orderProduct:"If you have difficulty ordering, you can order via WhatsApp.",

    "dashboard": "Dashboard",
    "schools": "Schools",
    "structure": "School Structure",
    "stages": "Stages",
    "grades": "Grades",
    "grade": "Grade",

    "subjects": "Subjects",
    "subject": "Subject",

    "teachers": "Teachers",
    "teacher": "Teacher",

    "classes": "Classes & Schedules",
    "addclass": "Add Class",
"MaxStudents":"Max Students",
"sessionnumber":"Sessions Number",
"Session":"Session",
"class": "Class",

    
"students": "Students",
"addStudents": "Add Students",
    


    "attendanceHistory": "Attendance History",
    "markAttendance": "Mark Attendance",
    "profile": "profile",
    details:"details",
proccing:"Proccing",
shipped:"Shipped",
delivered:"Delivered",
    yoursecurity:"Update your details and manage your security",
    UserProfile:"User Profile",Personalinformation:"Personal information",
Subtotal:"Sub total",
discount:"discount",
shipping:"Shipping",
total:"Total",
trackingNumber:"Tracking number",
Estimateddelivery:"Estimated delivery",
checkout:"Checkout",
    price: "Price",
Quantity:"Quantity",


    "changePassword": "change Password",UpdateProfile:"Update Profile",
    "logout": "Logout",
    "export": "Export",
    "schoolID": "school ID",
    "addschools": "add School",
    "Save":"Save",
    "SelectGender":"Select Gender",
    "gender":"Gender",

    "male":"Male",
    "female":"Female",
    "Oldpassword":"Current password",
    "Newpassword":"New password",
    "Confirmpassword":"Confirm password ",
    "SchoolStracture":"School Stracture",
    "addStage":"Add Stage",
    "add":"Add",
    "stageName":"Stage Name",
    "gradeName":"Grade Name",
    "ID":"ID",
    "AddGrades":"Add Grades",
    "SelectStage":"Select Stage",
    "addSubject":"Add Subject",
    "Semester":"Semester",
    "SelectGrades":"Select Grades",
    "SelectSemester":"Select Semester",
    "SelectSubject":"Select Subject",

    "secondsemester":"Second Semester",
    "firstsemster":"First Semester",
"addteachers":"Add Teachers",
"SelectTimeTable":"Select Time Table",
"SelectClass":"Select Class",
"SelectTeacher":"Select Teacher",
"Day":"Day",


 'monday': 'Monday',
 'tuesday': 'Tuesday',
 'wednesday': 'Wednesday',
 'thursday': 'Thursday',
 'friday': 'Friday',
 'saturday': 'Saturday',
 'sunday': 'Sunday',
 "Selectday":"Select day",
 "TodaysAttendance":"Today's Attendance",
 Days:"Days",
"SelectSession":"Select Session",
"Selectyear":"Select Year",
"status":"Status",
"settings":"Settings",
"firstSection":"First Section",
"secondSection":"Second Section",
"thirdSection":"Third Section",


title_en: "Title in English",
title_ar: "Title in Arabic",


description_en: "Description in English",
description_ar: "Description in Arabic",

image: "image",
UploadMainImage:"Upload Main Image",
ClickorDraganImage:"Click or Drag an Image",


subtitle1_en: "Subtitle 1 in English",
subtitle_en: "Subtitle  in English",

subtitle_ar: "Subtitle  in Arabic",


subtitle2_en: "Subtitle 2 in English",
subtitle2_ar: "Subtitle 2 in Arabic",

subtitle3_en: "Subtitle 3 in English",
subtitle3_ar: "Subtitle 3 in Arabic",

subtitle4_en: "Subtitle 4 in English",
subtitle4_ar: "Subtitle 4 in Arabic",



subdescribtion1_en: "Sub-description 1 in English",
subdescribtion_en: "Sub-description  in English",
subdescribtion1_ar: "Sub-description 1 in Arabic",

subdescribtion2_en: "Sub-description 2 in English",
subdescribtion2_ar: "Sub-description 2 in Arabic",
subdescribtion_ar: "Sub-description  in Arabic",



subdescribtion3_en: "Sub-description 3 in English",
subdescribtion3_ar: "Sub-description 3 in Arabic",


subdescribtion4_en: "Sub-description 4 in English",
describtion: "Describtion",
"Generaldata":"General data",
terms:"Terms & Conditons",


"notfountTitle":"Page Not found",
"notfountParagraph1":"We are sorry, The page you requested could not be found",
"notfountParagraph2":"Please go back to the homepage",
"MarkAttendance":"Mark Attendance",
"areyousureyouwantdelet":"Are you sure you want to delete this?",
"delete":"Delete",
Default:"Default",
    priceAfterDisc:"price sfter discount",
myOrder:"My Orders",
order:"Order",

"close":"Close",
"edit":"Edit",
"notmatch":"New password and confirm password do not match!",
"from":"From",
"to":"To",
"chooseStageFirst":"please choose stage first",
"chooseGradeandSemsterirst":"choose Grade and Semester first",
"chooseGradefirst":"choose Grade first",
    "deleteTimeTable":"Delete timetable",
Congratulations:"Congratulations! ✅ Your product is original and guaranteed by Heaven Smile.Thank you for your trust in our products 💙",
Warning:"“Warning ⚠️ This code has already been checked.It may have been checked by you, or it may have been used in a counterfeit product.If you have any questions, please contact Heaven Smile customer service.”",
InvalidcodeMsg:"“Sorry ❌ The code you entered is incorrect.This means the product is either counterfeit or fake.For your safety, please only purchase Heaven Smile products from authorized distributors.”",
    seeOffer:"see Offer",

"howtouse":"How to use",
"activeIngredients":"Active ingredients",
"Benefitsofuse":"Benefits of use",
enterCode:"Enter product code",
goback:"Return to enter a new code",
"bestseller":"Best products",
"seeMore":"See More",










  },
};
